/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_Tier_CompetitiveInputs */



/**
* | output |
* | --- |
* | "Competitive" |
*
* @param {Meta_Event_Tier_CompetitiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_tier_competitive = /** @type {((inputs?: Meta_Event_Tier_CompetitiveInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_Tier_CompetitiveInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kompetitiv")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compétitif")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("竞技")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("競技")
	if (locale === "ko") return /** @type {LocalizedString} */ ("경쟁")
	return /** @type {LocalizedString} */ ("Competitive")
});